import { Model } from '@/models/Model';
import { Order } from '@/models/Order';
import { Set } from '@/models/Set';
import { ProductVariant } from '@/models/ProductVariant';

export class SetItem extends Model {
  protected $name: string = 'SetItem';
  protected $endpoint: string = '/orders/{id}/relationships/set-items';
  protected $fillable: string[] = [
    'order_item',
    'pack_with_this_set',
    'setId',
    'text',
  ];

  public id?: string;
  public name?: string;
  public explanation?: boolean;
  public order_item_id?: string;
  public order_item?: string;
  public pack_with_this_set?: boolean | string;
  public product?: Partial<ProductVariant>;
  public set_items?: SetItem[];
  public status?: string;
  public text?: string;
  public updated_at?: string;
  public created_at?: string;

  public setId?: string;

  public order(order: Order | string) {
    if(typeof order !== 'string') {
      order = order.id || '';
    }

    this.$endpoint = `/orders/${order}/relationships/sets`;

    return this;
  }

  public set(set: Set | string) {
    if(typeof set !== 'string') {
      set = (set as any).id || '';
    }

    this.$endpoint += `/${set}/relationships/set-items`;

    return this;
  }

  deleteSetItem(orderId: string, setId: string, id: string) {
    const url = `/orders/${orderId}/relationships/sets/${setId}/relationships/set-items/${id}`;
    return this.request('delete', url);
  }

  updateSetItem(orderId: string, setId: string, id: string, payload: any) {
    const url = `/orders/${orderId}/relationships/sets/${setId}/relationships/set-items/${id}`;
    return this.request('patch', url, payload);
  }

  public resolvePrimaryKey(): string {
    return '';
  }
}
